const privacyPolicy = 'https://www.parkholidays.com/privacy-policy';

const paymentClientPrd = 'https://3bnl7ls890.execute-api.eu-west-2.amazonaws.com/default/niobeservice_payment_production';
const paymentClientStaging = 'https://3mafqbe4xe.execute-api.eu-west-2.amazonaws.com/default/niobeservice_payment_staging';

const vfastProxyUrl = process.env.REACT_APP_VFAST_PROXY_URL;
const vfastProxyKey = process.env.REACT_APP_VFAST_PROXY_KEY;

// Direct-to-controller Lambda for To-Be (portal-02) parks
const directProxyUrl = process.env.REACT_APP_DIRECT_PROXY_URL;
const directProxyKey = process.env.REACT_APP_DIRECT_PROXY_KEY;

export { privacyPolicy, paymentClientPrd, paymentClientStaging, vfastProxyUrl, vfastProxyKey, directProxyUrl, directProxyKey }
